import { useQuery } from '@tanstack/react-query';
import { searchProducts } from '../providers/productFinderAPI';
import { queryKeys, SearchParams } from './queryKeys';
import ProductTypes from '../enum/ProductTypesEnum';

export const useProductSearch = (searchParams: SearchParams, enabled = true) => {
  const onlyETOSelected =
    searchParams.options?.enabledProductTypes?.length === 1 &&
    searchParams.options.enabledProductTypes[0] === ProductTypes.Eto;
  return useQuery({
    queryKey: queryKeys.products(searchParams),
    queryFn: ({ signal }) =>
      searchProducts(
        searchParams.bearerToken,
        searchParams.filters,
        searchParams.indexNames,
        signal,
        searchParams.options
      ),
    enabled: enabled && !!searchParams.bearerToken && (searchParams.filters.length > 0 || onlyETOSelected),
  });
};
